export const startValidation = `mutation ($kmatID: String!, $modVer: String!) {
    startValidation(kmatID: $kmatID, modVer: $modVer)
  }`;
